import { render, staticRenderFns } from "./NoOrder.vue?vue&type=template&id=56b0be3a&scoped=true"
import script from "./NoOrder.vue?vue&type=script&lang=js"
export * from "./NoOrder.vue?vue&type=script&lang=js"
import style0 from "./NoOrder.vue?vue&type=style&index=0&id=56b0be3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0be3a",
  null
  
)

export default component.exports